import { useState } from 'preact/hooks';
import { haptic } from '../lib/haptics.js';

/**
 * Arrival with no room in the URL.
 *
 * Almost everyone reaches a show through a shared link, so this is the
 * fallback, not the front door. One field, one action, no marketing.
 */
export function Landing({ onOpen }: { onOpen: (roomId: string) => void }) {
  const [code, setCode] = useState('');
  const clean = code.trim().toLowerCase();
  const valid = /^[a-z0-9][a-z0-9-]{2,63}$/.test(clean);

  return (
    <main class="door">
      <div class="door__card">
        <div class="door__eyebrow">
          <span class="chip">Waves of Africa</span>
        </div>
        <h1 class="door__title">Live rooms, made for listening.</h1>
        <p class="door__meta">Open the link you were sent, or enter a room code.</p>

        <form
          class="door__form"
          onSubmit={(event) => {
            event.preventDefault();
            if (!valid) return;
            haptic('press');
            onOpen(clean);
          }}
        >
          <div class="door__field">
            <label for="code">Room code</label>
            <input
              id="code"
              value={code}
              placeholder="lagos-comedy-night"
              autocomplete="off"
              autocapitalize="none"
              spellcheck={false}
              enterkeyhint="go"
              onInput={(event) => setCode((event.target as HTMLInputElement).value)}
            />
          </div>
          <button class="door__join" type="submit" disabled={!valid}>
            Open room
          </button>
        </form>
      </div>
    </main>
  );
}
